import React, { createContext, useCallback, useEffect, useState } from "react";

export const HRLocaleContext = createContext({ locale: "tr", setLocale: () => {} });

export default function HRLocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => {
    if (typeof window === "undefined") return "tr";
    // "lang" is the retired legacy key — read it once for continuity.
    return (
      window.localStorage.getItem("hr-locale") ||
      window.localStorage.getItem("lang") ||
      "tr"
    );
  });

  const setLocale = useCallback((next) => {
    setLocaleState(next);
    try { window.localStorage.setItem("hr-locale", next); } catch (e) {}
  }, []);

  useEffect(() => { document.documentElement.lang = locale; }, [locale]);

  return (
    <HRLocaleContext.Provider value={{ locale, setLocale }}>
      {children}
    </HRLocaleContext.Provider>
  );
}
